import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NavigationModule } from "src/app/shared/components/navigation/navigation.module";
import { AdministrationLayoutComponent } from "./administration-layout.component";

@NgModule({
  declarations: [AdministrationLayoutComponent],
  imports: [CommonModule, RouterModule, NavigationModule],
})
export class AdministrationLayoutModule {}
